export default class BackboneDispatcher
  @get_instance: ->
    window._backboneDispatcherInstance ?= _.clone(Backbone.Events)



// WEBPACK FOOTER //
// ./app/javascript/lib/backbone_dispatcher.js.coffee